// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"c9d6838f","355":"79e65ce1","363":"60f3c64a","393":"83999e4a","453":"3a887bee","530":"102e894e","632":"07da14b7","654":"d8548c6d","667":"6b1a5441","813":"65f9fe3d","825":"5da2caa9","953":"14f74846","982":"db37c920","989":"aff24fd5"}[chunkId] + ".chunk.js";
};